import ReportEdit from 'components/reports/ReportEdit';
import { BaseModel } from 'model/BaseModel';
import Pageable from 'model/page/Pageable';
import Estoque from 'model/suprimentos/Estoque';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { Column, ColumnFilterElementTemplateOptions, ColumnSortEvent } from 'primereact/column';
import { ColumnGroup } from 'primereact/columngroup';
import { DataTable, DataTableFilterMeta, DataTableStateEvent } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { Row } from 'primereact/row';
import React, { useEffect, useState } from 'react';
import EstoqueService from 'service/suprimentos/EstoqueService';
import { converterData } from 'utils/convert';
import saveAs from 'file-saver';
import UsuarioLogadoService from 'service/usuario/UsuarioLogadoService';
import { SplitButton } from 'primereact/splitbutton';
import { useToastContext } from 'components/alert/ToastContext';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { Dropdown } from 'primereact/dropdown';
import Deposito from 'model/suprimentos/Deposito';
import Produto from 'model/administracao/cadastro/produto/Produto';
import OrigemProduto from 'model/administracao/cadastro/produto/OrigemProduto';
import FamiliaProduto from 'model/administracao/cadastro/produto/FamiliaProduto';
import { IdMatchModeOptions, NumberMatchModeOptions, ProdutoFilterTemplate, TextMatchModeOptions, decimalFilterTemplate, filterApplyTemplate } from 'utils/filterUtils';
import { useFilter } from 'contexts/FilterContext';
import EstoqueInutilizavelService from 'service/patrimonio/EstoqueInutilizavelService';
import EstoqueLote from 'model/suprimentos/EstoqueLote';
import DescarteInutilizavel from 'model/patrimonio/DescarteInutilizavel';
import { InputNumber } from 'primereact/inputnumber';
import { Label } from 'components/input/Label';
import DescarteInutilizavelModal from './DescarteInutilizavelModal';
import TransferenciaInutilizavelModal from './TransferenciaInutilizavelModal';
import TransferenciaEstoque from 'model/suprimentos/TransferenciaEstoque';
import { useLoadingContext } from 'provider/LoadingProvider';

interface Props {

}

const estoqueInutilizavelService = new EstoqueInutilizavelService();
const usuarioLogadoService = new UsuarioLogadoService();

function EstoqueInutilizavelConsulta(props: Props) {

    const defaultFilters = {
        origemProduto: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        familiaProduto: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        produto: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        nomeProduto: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        deposito: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        quantidadeInutilizavel: {
            constraints: [
                {
                    value: 0,
                    matchMode: FilterMatchMode.GREATER_THAN,
                }
            ],
            operator: FilterOperator.AND
        }
    }

    const filterContext = useFilter();
    const screen = "estoqueInutilizavelConsulta";

    const [pageable, setPageable] = useState(new Pageable(0, 10, "produto.id.codigo,desc", 0));
    const [filtrando, setFiltrando] = useState<boolean>(false);
    const [list, setList] = useState<BaseModel[]>([]);
    const [totalElements, setTotalElements] = useState<number>(0);
    const [visibleEditarRelatorio, setVisibleEditarRelatorio] = useState<boolean>(false);
    const [editaRelatorios, setEditaRelatorios] = useState<boolean>(false);
    const [ativaDesativaLote, setAtivaDesativaLote] = useState<boolean>(false);

    const [visibleConfiguracoes, setVisibleConfiguracoes] = useState<boolean>(false);
    const [esconderCodigos, setEsconderCodigos] = useState<boolean>(false);

    const [filters, setFilters] = useState<DataTableFilterMeta>(filterContext.filters[screen] ? filterContext.filters[screen] : defaultFilters);
    const [familias, setFamilias] = useState<FamiliaProduto[]>([]);
    const [origens, setOrigens] = useState<OrigemProduto[]>([]);
    const [produtos, setProdutos] = useState<Produto[]>([]);
    const [depositos, setDepositos] = useState<Deposito[]>([]);

    const {startLoading, stopLoading} = useLoadingContext();
    const [modalTransferencia, setModalTransferencia] = useState<{ visible: boolean }>({ visible: false });
    const [modalDescartar, setModalDescartar] = useState<{ visible: boolean, data: any, isRecup: boolean }>({ visible: false, data: null, isRecup: false });
    const [estoqueSelecionado, setEstoqueSelecionado] = useState<Estoque | null>(null);

    const { msgSucesso, msgErro, msgAlerta } = useToastContext();

    useEffect(() => {
        setEsconderCodigos(localStorage.getItem("esconderCodigos") == "true")
        usuarioLogadoService.getAcoesUsuarioLogado().then((resposta) => {
            if (usuarioTemAcao(resposta, "RELATORIO_SUPRIMENTOS_NECESSIDADE_COMPRA")) {
                setEditaRelatorios(true);
            }
            if (usuarioTemAcao(resposta, "LOTE_ATIVAR_DESATIVAR")) {
                setAtivaDesativaLote(true);
            }
        }).catch((erro) => {
            console.log(erro);
        });

        estoqueInutilizavelService.familias().then(lista => {
            setFamilias(lista);
        }).catch(err => {
            console.log(err);
        });
        estoqueInutilizavelService.origens().then(lista => {
            setOrigens(lista);
        }).catch(err => {
            console.log(err);
        });
        estoqueInutilizavelService.getProdutos().then(lista => {
            setProdutos(lista);
        }).catch(err => {
            console.log(err);
        });
        estoqueInutilizavelService.getDepositos().then(lista => {
            setDepositos(lista);
        }).catch(err => {
            console.log(err);
        });
    }, [])

    useEffect(() => {
        filterContext.updateFilters(screen, filters);

        console.log(pageable);
        console.log(filters);
        estoqueInutilizavelService.pesquisar(pageable, filters).then((response) => {
            setList(response.content);
            setTotalElements(response.totalElements);
        }).catch((error) => {
            console.log(error);
        });

    }, [pageable, filters]);

    function usuarioTemAcao(acoes: any, acao: any): boolean {
        return acoes.some((a: any) => a.sigla === acao);
    }

    const filterField = (options: ColumnFilterElementTemplateOptions, list: any, label?: string) => {
        return <Dropdown value={options.value} options={list}
            onChange={(e) => options.filterCallback(e.value)}
            optionLabel={label || "nome"} optionValue="codigo" placeholder="Qualquer" className="p-column-filter" />
    }

    const numberTemplate = (rowData: any, options: any) => {
        if (rowData[options.field] === null || rowData[options.field] === undefined) {
            return "";
        }
        return new Intl.NumberFormat('pt-BR', { style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 6 }).format(rowData[options.field]);
    };

    const headerColumnGroup = (
        <ColumnGroup>
            <Row>
                <Column header="Origem" rowSpan={1} colSpan={esconderCodigos ? 1 : 2} filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="origemProduto"
                    filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options) => filterField(options, origens)} />
                <Column header="Familia" rowSpan={1} colSpan={esconderCodigos ? 1 : 2} filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="familiaProduto"
                    filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options) => filterField(options, familias)} />
                <Column header="Produto" rowSpan={1} colSpan={esconderCodigos ? 1 : 2} filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="produto"
                    filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options) => <ProdutoFilterTemplate options={options} opcoes={produtos} />} />
                <Column header="Depósito" rowSpan={1} colSpan={esconderCodigos ? 1 : 2} filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="deposito"
                    filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options) => filterField(options, depositos)} />
                <Column header="Quantidade Inutilizável" rowSpan={2} filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="quantidadeInutilizavel"
                    filterMatchModeOptions={NumberMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options) => decimalFilterTemplate(options)} sortable sortField='quantidadeInutilizavel' />
            </Row>
            <Row>
                {!esconderCodigos ? <Column header="Código" sortable sortField='produto.familia.cdOrigem' /> : null}
                <Column header="Nome" sortable sortField='produto.familia.origemProduto.nome' />
                {!esconderCodigos ? <Column header="Código" sortable sortField='produto.cdFamilia' /> : null}
                <Column header="Nome" sortable sortField='produto.familia.nome' />
                {!esconderCodigos ? <Column header="Código" sortable sortField='produto.id.codigo' /> : null}
                <Column header="Nome" sortable sortField='produto.nome' filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="nomeProduto"
                    filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
                {!esconderCodigos ? <Column header="Código" sortable sortField='deposito.id.codigo' /> : null}
                <Column header="Nome" sortable sortField='deposito.nome' />
            </Row>
        </ColumnGroup>
    );

    const descartar = (descarteInutilizavel: DescarteInutilizavel) => {
        startLoading();
        estoqueInutilizavelService.descartar(descarteInutilizavel).then(() => {
            carregar();
            msgSucesso('Descartado', 'Lote Descartado com sucesso');
            stopLoading();
        }).catch((err) => { 
            msgErro('Erro ao Emprestar', err?.data?.message || ""); 
            stopLoading();
        });
    }

    const recuperar = (descarteInutilizavel: DescarteInutilizavel) => {
        startLoading();
        estoqueInutilizavelService.recuperar(descarteInutilizavel).then(() => {
            carregar();
            msgSucesso('Descartado', 'Lote Descartado com sucesso');
            stopLoading();
        }).catch((err) => { 
            msgErro('Erro ao Emprestar', err?.data?.message || ""); 
            stopLoading();
        });
    }

    const transferir = (transferenciaEstoque: TransferenciaEstoque) => {
        startLoading();
        estoqueInutilizavelService.transferir(transferenciaEstoque).then(() => {
            carregar();
            msgSucesso('Descartado', 'Lote Descartado com sucesso');
            stopLoading();
        }).catch((err) => { 
            msgErro('Erro ao Emprestar', err?.data?.message || ""); 
            stopLoading();
        });
    }

    const carregar = () => {
        filterContext.updateFilters(screen, filters);

            let estoqueSelecionadoAtual = estoqueSelecionado;
            let estoqueEncontrado: Estoque | null = null;

            estoqueInutilizavelService.pesquisar(pageable, filters).then((response) => {
                for(let i = 0; i < response.content.length; i++){
                    let estoque: Estoque = response.content[i];
                    if(estoque.produto.codigo == estoqueSelecionadoAtual?.produto.codigo 
                        && estoque.deposito.codigo == estoqueSelecionadoAtual?.deposito.codigo) {
                            estoqueEncontrado = estoque;
                    }
                }

                setEstoqueSelecionado(estoqueEncontrado);
                setList(response.content);
                setTotalElements(response.totalElements);
            }).catch((error) => {
                console.log(error);
            });
    }

    const clearFilter = () => {
        setFilters(defaultFilters || {});
    }

    return (
        <div>
            <Dialog header="Configurações" visible={visibleConfiguracoes} onHide={() => setVisibleConfiguracoes(false)}>
                <div style={{ display: "flex", padding: 20 }}>
                    <Checkbox checked={esconderCodigos} onChange={(e) => {
                        localStorage.setItem("esconderCodigos", e.checked as boolean ? "true" : "false");
                        setEsconderCodigos(e.checked as boolean);
                    }} style={{ marginRight: 8 }} />
                    <label>Esconder códigos</label>
                </div>
            </Dialog>
            <DescarteInutilizavelModal
                visible={modalDescartar.visible}
                setVisible={(visible) => { setModalDescartar({ visible: visible, data: new EstoqueLote(), isRecup: false }) }}
                estoqueLote={modalDescartar.data}
                isRecup={modalDescartar.isRecup}
                onConfirm={(descarteInutilizavel) => {
                    if(modalDescartar.isRecup){
                        recuperar(descarteInutilizavel);
                    }else {
                        descartar(descarteInutilizavel);
                    }
                }}
            />
            <TransferenciaInutilizavelModal
                visible={modalTransferencia.visible}
                setVisible={(visible) => { setModalTransferencia({ visible: visible }) }}
                onConfirm={(transferenciaInutilizavel) => {
                    console.log(transferenciaInutilizavel);
                    transferir(transferenciaInutilizavel);
                }}
            />
            <DataTable
                onSort={(e: DataTableStateEvent) => {
                    let sort = e.sortField ? e.sortField : "";
                    sort += e.sortOrder === 1 ? ",asc" : e.sortOrder === -1 ? ",desc" : "";
                    setPageable({ ...pageable, sort: sort });

                }}
                sortField={pageable.sort.split(",")[0]}
                sortOrder={pageable.sort.split(",")[1] === "asc" ? 1 : pageable.sort.split(",")[1] === "desc" ? -1 : 0}
                filters={filters}
                onFilter={(e) => setFilters(e.filters)}
                header={<div style={{ display: "flex", justifyContent: "space-between", textAlign: 'center', alignContent: "center" }}>
                    <div></div>
                    <span style={{ textAlign: 'center', width: "100%", alignSelf: "center", position: 'relative' }}>Estoque</span>
                    <div style={{ display: "flex", justifyContent: "flex-end" }}>
                        <Button type="button" label="Transferir" onClick={() => setModalTransferencia({visible: true})} style={{ marginRight: 8 }} />
                        <Button type="button" icon="pi pi-cog" onClick={() => setVisibleConfiguracoes(true)} style={{ marginRight: 8 }} />
                        <Button type="button" icon="pi pi-filter-slash" label="Limpar" outlined onClick={clearFilter} style={{ marginRight: 8 }} />

                    </div>
                </div>}
                value={list}
                scrollable scrollHeight="calc(100vh - 300px)"
                headerColumnGroup={headerColumnGroup}
                emptyMessage="Nenhum registro encontrado"
                first={pageable.first} rows={10} lazy
                onPage={(event) => { setPageable({ ...pageable, page: event.page !== undefined ? event.page : 0, first: event.first }) }}
                paginator={true} totalRecords={totalElements}
                selection={estoqueSelecionado as BaseModel} selectionMode="single" onSelectionChange={(e) => setEstoqueSelecionado(e.value as Estoque)}
            >
                {!esconderCodigos ? <Column field="produto.familiaProduto.origemProduto.codigo" style={{ minWidth: "75px" }}></Column> : null}
                <Column field="produto.familiaProduto.origemProduto.nome" style={{ minWidth: "175px" }}></Column>
                {!esconderCodigos ? <Column field="produto.familiaProduto.codigo" style={{ minWidth: "75px" }}></Column> : null}
                <Column field="produto.familiaProduto.nome" style={{ minWidth: "175px" }}></Column>
                {!esconderCodigos ? <Column field="produto.codigo" header="Código"></Column> : null}
                <Column field="produto.nome" header="Produto"></Column>
                {!esconderCodigos ? <Column field="deposito.codigo" header="Código Depósito"></Column> : null}
                <Column field="deposito.nome" header="Depósito"></Column>
                <Column field="quantidadeInutilizavel" header="Quantidade Inutilizável"
                    style={{ minWidth: "115px" }} body={numberTemplate}></Column>

            </DataTable>

            <DataTable
                header={<div style={{ display: "flex", justifyContent: "space-between", textAlign: 'center', alignContent: "center" }}>
                    <span style={{ textAlign: 'center', width: "100%", alignSelf: "center", position: 'relative' }}>Lote</span>
                </div>}
                emptyMessage="Nenhum registro encontrado"
                value={estoqueSelecionado?.lotes} style={{ marginTop: 20 }}
            >
                <Column field="lote" header="Lote"></Column>
                <Column field="ativo" header="Ativo" body={(rowData) => <Checkbox checked={rowData.ativo} readOnly={true} />}></Column>
                <Column field="validade" header="Validade" body={(rowData) => converterData(rowData.validade)}></Column>
                <Column field="quantidadeInutilizavel" header="Quantidade Inutilizável" body={numberTemplate}></Column>
                <Column
                    body={(rowData) => (
                        rowData.quantidadeInutilizavel? (<div>
                            <Button label="Descartar" onClick={() => {
                                setModalDescartar({ visible: true, data: rowData, isRecup: false })
                            }} style={{ marginLeft: 8 }} />

                            <Button label="Recuperar" onClick={() => {
                                setModalDescartar({ visible: true, data: rowData, isRecup: true })
                            }} style={{ marginLeft: 8 }} />
                        </div>) : <div></div>
                    )}
                />
            </DataTable>
        </div>
    );
};

export default EstoqueInutilizavelConsulta;